module.exports = (__webpack_require__(5))(23);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/AccessWidget.js from dll-reference girder_plugin_large_image_annotation
// module id = 101
// module chunks = 0